import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaGavel, FaHandshake, FaFileContract } from "react-icons/fa";
import { motion } from "framer-motion";

const WhyAttorney = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section
      id="why-attorney"
      className="why-attorney-section"
    >
      {/* Overlay */}
      <div
        className="py-5"
        style={{
          backgroundColor: "rgba(179, 166, 145, 0.88)",
        }}
      >
        <Container>
          {/* Heading */}
          <motion.h2
            className="text-center fw-bold mb-3"
            style={{
              fontFamily: "'Calisto MT', 'Bookman Old Style', Georgia, serif",
            }}
            initial={{ opacity: 0, y: -40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            WHEN YOU NEED AN ATTORNEY
          </motion.h2>

          {/* Subtitle */}
          <motion.p
            className="text-center mb-5 text-dark"
            style={{ maxWidth: "700px", margin: "0 auto" }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            Navigating legal matters can be complex and overwhelming.{" "}
            <span className="fw-semibold text-primary">
              Experienced attorneys
            </span>{" "}
            ensure your rights are protected, guide your decisions, and provide
            solutions that achieve results.
          </motion.p>

          {/* Cards */}
          <Row className="g-4 justify-content-center text-center">
            
            <Col md={4}>
              <motion.div
                className="bg-white p-4 rounded shadow h-100"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <FaGavel size={45} className="text-primary" />

                <h5
                  className="fw-bold mt-3"
                  style={{
                    fontFamily:
                      "'Calisto MT', 'Bookman Old Style', Georgia, serif",
                  }}
                >
                  Legal Expertise
                </h5>

                <p className="text-muted mb-0">
                  Attorneys provide expert advice across all legal areas,
                  ensuring you make informed decisions and avoid costly mistakes.
                </p>
              </motion.div>
            </Col>

            <Col md={4}>
              <motion.div
                className="bg-white p-4 rounded shadow h-100"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
              >
                <FaHandshake size={45} className="text-primary" />

                <h5
                  className="fw-bold mt-3"
                  style={{
                    fontFamily:
                      "'Calisto MT', 'Bookman Old Style', Georgia, serif",
                  }}
                >
                  Trusted Guidance
                </h5>

                <p className="text-muted mb-0">
                  From personal disputes to business agreements, attorneys guide
                  you through legal processes, giving you confidence and peace
                  of mind.
                </p>
              </motion.div>
            </Col>

            <Col md={4}>
              <motion.div
                className="bg-white p-4 rounded shadow h-100"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
              >
                <FaFileContract size={45} className="text-primary" />

                <h5
                  className="fw-bold mt-3"
                  style={{
                    fontFamily:
                      "'Calisto MT', 'Bookman Old Style', Georgia, serif",
                  }}
                >
                  Protect Your Interests
                </h5>

                <p className="text-muted mb-0">
                  Professional legal support safeguards your rights, ensures
                  compliance, and helps achieve successful outcomes in all
                  matters.
                </p>
              </motion.div>
            </Col>

          </Row>

          {/* CTA */}
          <motion.div
            className="text-center mt-5"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Button variant="primary" href="#contact" className="px-4">
              Speak to an Attorney Today
            </Button>
          </motion.div>
        </Container>
      </div>
    </section>
  );
};

export default WhyAttorney;